import { createSelector } from 'reselect'

const getAdminOnboardingData = state => state.adminOnboarding

const stepAdminOnboarding = createSelector(
	[getAdminOnboardingData],
	adminOnboarding => {

		const timeToComplete = adminOnboarding.adminOnboardingInitializeTime ?
			Math.round((Date.now() - adminOnboarding.adminOnboardingInitializeTime) / 1000)
			: 0

		return timeToComplete
	}
)

export default stepAdminOnboarding
